import { LanguageCode } from '@cms-max/medicare-api-sdk'

export function buildLogoutUrl (language: LanguageCode) {
  const langParam = language === 'es' ? 'es-mx' : 'en-us'
  // Logout doesn't use the es subdomain so we can just use the medicare env field without any subdomain logic
  return `https://${process.env.REACT_APP_MEDICARE_ENV}.medicare.gov/account/logout?lang=${langParam}`
}
